import React, { useEffect, useState } from "react";
import profile from "../../assets/images/star-profile-img.png";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { Button, Col, Row } from "react-bootstrap";
import { ChevronLeft, ChevronRight, User } from "lucide-react";
import Paginator from "../../components/Paginator";
import Swal from 'sweetalert2';
import Lottie from "lottie-react";
import NoDataAnimation from "../../assets/animations/No Result Green theme.json"
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Image from "../../components/Image";

const HistoryCard = ({ item, fetchProjectData }) => {
  const statusStyles = {
    Pending: { color: "#CD496D", bg: "#FCE1E8" },
    Completed: { color: "#5F8D73", bg: "#D3FDEA" },
    "In Progress": { color: "#5F8D73", bg: "#D3FDEA" },
    "Up Coming": { color: "#CD496D", bg: "#FCE1E8" },
  };

  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { color, bg } =
    statusStyles[item.paymentStatus] || statusStyles["Pending"];
const navigate = useNavigate();
  const handleUpdateStatus = async (id, status) => {
    try {
       const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to '+status,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: (status=="Accepted")?'#2C9E4B':'#BE3601',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
          setIsLoading(true);

          const formdata = new FormData();
          formdata.append("project_id", id);
          formdata.append("status", status);

          const res = await ApiService.request({
            method: "POST",
            url: `projects/updateStatus`,
            data: formdata,
          });

          if (res.data.status) {
            // setCreateJobData(false);
            await fetchProjectData(1);

            toast.success(res.data.message);
          } else {
            toast.error(res.data.message);
          }
        }
    } catch (err) {
      console.error("Edit Error:", err);
      toast.error("Failed to update job.");
    } finally {
      setIsLoading(false);
    }
  };


  function formatSingleDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // or "long" for full month name
    return `${day} ${month}`;
  }

 const handleViewProject = (item) => {
    navigate("/talent/project-details", { state: { project: item} });
  };
  return (
<div className="inter-font bg-white rounded-4 shadow-sm p-3">
  <div className="table-responsive">
    <table 
      className="table align-middle mb-0"
      style={{ direction: isRTL ? "rtl" : "ltr" }}
    >
      <thead className="bg-light">
        <tr>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text86")} {/* Company Name */}
          </th>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text84")} {/* Project Name */}
          </th>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text87")} {/* Duration (Days) */}
          </th>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text88")} {/* Dates */}
          </th>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text85")} {/* Amount */}
          </th>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text83")} {/* Status */}
          </th>
          <th style={{ 
            fontWeight: "600", 
            fontSize: "15px",
            textAlign: isRTL ? "right" : "left"
          }}>
            {t("t_d_text89")} {/* Action */}
          </th>
        </tr>
      </thead>

      <tbody>
        {item?.map((item, index) => {
          let color = "#777474";
          let bg = "#EFEFEF";
          if (item.status === "Accepted") {
            color = "#198754";
            bg = "#D3FDEA";
          } else if (item.status === "Rejected") {
            color = "#DC3545";
            bg = "#FCE1E8";
          } else if (item.status === "Pending") {
            color = "#B6813C";
            bg = "#FFF5E0";
          }

          return (
            <tr key={index}>
              {/* Company Name */}
              <td style={{ textAlign: isRTL ? "right" : "left" }}>
                <div 
                  className="d-flex align-items-center"
                  style={{ 
                    flexDirection: isRTL ? "row-reverse" : "row",
                    gap: "8px"
                  }}
                >
                  <Image
                    src={item?.project_id?.company_id?.logo}
                    alt="Company"
                    className="rounded-circle"
                    style={{ 
                      width: "40px", 
                      height: "40px", 
                      objectFit: "cover",
                      [isRTL ? "marginLeft" : "marginRight"]: "8px"
                    }}
                  />
                  <span style={{ fontSize: "15px", color: "#333" }}>
                    {item?.project_id?.company_id?.company_name || "N/A"}
                  </span>
                </div>
              </td>

              {/* Job Name */}
              <td style={{ 
                fontSize: "15px", 
                color: "#555",
                textAlign: isRTL ? "right" : "left"
              }}>
                {item?.project_id?.title || "N/A"}
              </td>

              {/* Duration */}
              <td style={{ 
                fontSize: "15px", 
                color: "#555",
                textAlign: isRTL ? "right" : "left",
                direction: "ltr"
              }}>
               {parseInt(item?.duration) || 0}
              </td>

              {/* Dates */}
              <td style={{ 
                fontSize: "15px", 
                color: "#555",
                textAlign: isRTL ? "right" : "left",
                direction: "ltr"
              }}>
                {item.start_date ? formatSingleDate(item.start_date) : "N/A"} –{" "}
                {item.end_date ? formatSingleDate(item.end_date) : "N/A"}
              </td>

              {/* Amount */}
              <td style={{ 
                fontSize: "15px", 
                color: "#555",
                textAlign: isRTL ? "right" : "left",
                direction: "ltr"
              }}>
                {item.total_amount} AED
              </td>

              {/* Status */}
              <td style={{ textAlign: isRTL ? "right" : "left" }}>
                <span
                  className="px-2 py-1 rounded"
                  style={{
                    backgroundColor: bg,
                    color: color,
                    fontSize: "13px",
                    fontWeight: "500",
                    direction: "ltr"
                  }}
                >
                  {item.status} 
                  {item.status === 'Accepted' &&
                    <span className="ms-2" style={{ fontSize: "13px", fontWeight: "500", direction: "ltr" }}>
                      ({ item.payment_status === "Pending" ? t("in_progress") : t("hired")})
                    </span>
                  }
                </span>
              </td>

              {/* Action */}
              <td style={{ textAlign: isRTL ? "right" : "left" }}>
                <button
                  onClick={()=> handleViewProject(item)}
                  className="btn btn-sm px-3"
                  style={{ 
                    borderRadius: "6px", 
                    background:"#12CB71", 
                    color:"white",
                    direction: "ltr"
                  }}
                >
                  {t("t_d_text90")}
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</div>

  );
};

const History = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const totalPages = 5;

  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
  });
  const [projectData, setProjectData] = useState([]);

  const fetchProjectData = async (page = 1) => {
    try {
      setIsLoading(true);
      const res = await ApiService.request({
        method: "GET",
        url: `getProjectQuotes?page=${page}`,
      });

      const data = res.data;
      if (data.status) {
        setProjectData(data.data.projects);
        setPagination(data.data.pagination);
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      console.error("Fetch Job Error:", err);
      toast.error("Failed to fetch jobs.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= pagination.total_pages &&
      newPage !== pagination.current_page
    ) {
      fetchProjectData(newPage);
    }
  };



  useEffect(() => {
    fetchProjectData(1);
  }, []);

  return (
   <div className="inter-font " style={{ minHeight: "100vh" }}>
  <div className="inter-font rounded-3 m-4 d-flex flex-column  " style={{ minHeight: "79vh" }}>
    
    {/* Header */}
    <div className=" py-3 px-4">
      <h3 className="inter-font fw-semibold" style={{ fontSize: "20px" }}>
        {t("new_text_80")}
      </h3>
    </div>

    {/* Content */}
    <div className="flex-grow-1 px-4 py-3 d-flex flex-column">
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1">
          <div className="spinner-border" role="status"></div>
        </div>
      ) : projectData.length < 1 ? (
        <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1">
          <div style={{ width: 200 }}>
            <Lottie animationData={NoDataAnimation} loop={true} />
          </div>
        </div>
      ) : (
        <HistoryCard item={projectData} fetchProjectData={fetchProjectData} />
      )}

      {/* Pagination */}
      {pagination?.total_pages > 1 && (
        <div className="mt-auto">
          <Paginator
            page={pagination.current_page}
            rows={pagination.per_page}
            totalRecords={pagination.total_records}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
    
  </div>
</div>

  );
};

export default History;
